import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import { CardHolderSate } from '../../../../UserInputFields/CardHolderInput/CardHolderInput';
import { CreditCardState } from '../../../../UserInputFields/CreditCardInput/CreditCardInput';
import { DocumentState } from '../../../../UserDataFields/DocumentInput';

export const PayUErrorCode: { [id: string]: string } = {
  incorrect_cvc: I18N_STRINGS.INVALID_CVC_CVV,
  invalid_number: I18N_STRINGS.INVALID_CARD_NUMBER,
  incorrect_number: I18N_STRINGS.INCORRECT_CARD_NUMBER,
  expired_card: I18N_STRINGS.EXPIRED_CARD,
  card_declined: I18N_STRINGS.CARD_DECLINED,
  processing_error: I18N_STRINGS.CATCH_MESSAGE,
  invalid_expiry_year: I18N_STRINGS.INVALID_EXPIRATION_DATE,
  approve_with_id: I18N_STRINGS.INSUFFICIENT_FUNDS,
  withdrawal_count_limit_exceeded: I18N_STRINGS.INSUFFICIENT_FUNDS,
};

export class PayUError extends Error {
  public code: string;

  constructor(code: string) {
    super();
    this.code = code;
    this.message = PayUErrorCode[code] || I18N_STRINGS.CATCH_MESSAGE;
  }
}

const payuResponseHandler = (response: any) => {
  if (response.error) return { error: response.error, token: '' };
  return { token: response.token };
};

export function getPayUToken({
  creditCard,
  cardHolder,
  document,
}: {
  creditCard: CreditCardState;
  cardHolder: CardHolderSate;
  document: DocumentState;
}) {
  return new Promise<{ token: string; error?: string }>((resolve, _) => {
    const expiry = creditCard.expiration.split('/');

    const expMonth = expiry ? expiry[0] : 0;
    const expYear = expiry ? expiry[1] : 0;

    window.payU.setCardDetails({
      number: creditCard.number.replace(/\s+/g, ''),
      name_card: cardHolder.name,
      payer_id: '12345678',
      exp_month: expMonth,
      exp_year: `20${expYear}`,
      method: window.payU.cardPaymentMethod(creditCard.number),
      document: document.document,
      cvv: creditCard.cvc,
    });

    window.payU.getPaymentMethods();
    window.payU.createToken((response: any) =>
      resolve(payuResponseHandler(response)),
    );
  });
}
